import React, { createContext, useContext, useState } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);

  const addItem = (item) => {
    setCartItems((prev) => {
      const existing = prev.find((i) => i.bookId === item.bookId && i.customerId === item.customerId);
      if (existing) {
        return prev.map((i) =>
          i.bookId === item.bookId && i.customerId === item.customerId
            ? { ...i, quantity: i.quantity + item.quantity }
            : i
        );
      }
      return [...prev, item];
    });
  };

  const updateItem = (customerId, bookId, quantity) => {
    setCartItems((prev) =>
      prev.map((item) =>
        item.bookId === bookId && item.customerId === customerId ? { ...item, quantity } : item
      )
    );
  };

  const removeItem = (customerId, bookId) => {
    setCartItems((prev) => prev.filter((item) => !(item.bookId === bookId && item.customerId === customerId)));
  };

  const clearCart = (customerId) => {
    setCartItems((prev) => prev.filter((item) => item.customerId !== customerId));
  };

  return (
    <CartContext.Provider value={{ cartItems, addItem, updateItem, removeItem, clearCart }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);